import fs from 'fs';
const style = fs.readFileSync(__dirname + '/print-style.text', 'utf8');
export default style
